<style lang="scss" scoped>
.main {
  background: #ffffff;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;

  &-nav {
    padding: 20px 30px;
    position: absolute;
    top: 65px;
    left: 220px;
    right: 0;
    display: flex;
    transition: all 0.4s ease;
    &.on {
      left: 0px;
    }

    &::before {
      content: "";
      width: 3px;
      height: 18px;
      background: linear-gradient(0deg, #e84d4c 0%, #f58360 100%);
      border-radius: 2px;
    }
    span {
      padding-left: 13px;
      font-size: 16px;
      font-weight: 700;
      text-align: center;
      color: #585858;
    }
  }

  &-body {
    position: absolute;
    left: 244px;
    right: 30px;
    bottom: 46px;
    top: 127px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    transition: all 0.4s ease;
    &.on {
      left: 30px;
      bottom: 30px;
    }

    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: #f1f1f1;
    }
    /*定义滚动条轨道 内阴影+圆角*/
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 2px rgba(144, 147, 153, 0.3);
      border-radius: 10px;
      background-color: #f1f1f1;
    }
    /*定义滑块 内阴影+圆角*/
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 2px rgba(144, 147, 153, 0.3);
      background-color: #c1c1c1;
    }
  }
}
</style>

<template>
  <section class="main">
    <left-menu ref="child1Container" />
    <top-nav />
    <bottom-footer />
    <div :class="['main-nav', { on: $store.getters.getMeunShow }]">
      <span>{{ $route.meta.title }}</span>
    </div>
    <div :class="['main-body', { on: $store.getters.getMeunShow }]">
      <transition name="fade-transform" mode="out-in">
        <div>
          <router-view />
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import LeftMenu from "./components/LeftMenu";
import TopNav from "./components/TopNav";
import bottomFooter from "./components/bottomFooter";

export default {
  components: {
    LeftMenu,
    TopNav,
    bottomFooter,
  },
  computed:{
    jurisdiction(){
      return this.$store.state.pageJurisdiction?this.$store.state.pageJurisdiction:false
    }
  },
  data() {
    return {};
  },

  created() {},

  methods: {
    /**
     * 面包屑
     */
    getBreadcrumb(routes, route) {},
  },
};
</script>

